// extracted by mini-css-extract-plugin
export default {"colorDark":"#161616","h1":"62px","h2":"52px","h3":"20px","h4":"14px","p":"11px","titleFont":"Menlo","inputFieldFont":"Menlo","button":"Mfa_button__TXD1A"};